import { Delete } from '@workwave-tidal/core/icons'
import { useMemo } from 'react'
import * as Texts from './../../../intl'
import { preview } from '@/components/form/preview'
import { useReadOnlyTooltipData } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { useDeleteSimulationModal } from '../../../../modals/DeleteSimulationModal'
import { useActions } from '../hooks/useActions'

interface Props {
  simulations: uui.domain.client.rm.SimulationInfo[]
}

export function Header({ simulations }: Props) {
  const actions = useActions()
  const { preventEditing, title } = useReadOnlyTooltipData()
  const { Modal: DeleteSimulationModal } = useDeleteSimulationModal()

  const simulationIds = useMemo(() => simulations.map(simulation => simulation.id), [simulations])
  const simulationsCount: number = simulations.length

  return (
    <>
      <preview.Header
        title={Texts.getSimulationsCountText(simulationsCount)}
        testId="simulation-view-header"
        onClose={actions.onReset}
      >
        <preview.ActionBar>
          <preview.ActionBarItem
            icon={<Delete />}
            onClick={actions.onDelete}
            label={Texts.getDeleteText()}
            tooltip={preventEditing ? title : Texts.getDeleteText()}
            disableWhenReadOnly
            testId="simulation__delete"
            data-trackid="simulation__delete"
          />
        </preview.ActionBar>
      </preview.Header>

      <DeleteSimulationModal simulations={simulationIds} />
    </>
  )
}
